export default {
  errorsRootKey: 'countries',
  resource: 'countries',
  actions: ['index']
}
